import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  Injector,
  SimpleChange,
  AfterViewInit, Inject, PLATFORM_ID,
  OnDestroy,
} from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import {isPlatformBrowser, PlatformLocation} from '@angular/common';
import {fromEvent, Subscription} from 'rxjs';
import {debounceTime, map} from 'rxjs/operators';
import {countryConfig} from 'src/country-config/country-config';
import {AlgoliaSearchService} from './algolia-search.service';
import {AlgoliaVm} from '../../../../view-model/algolia/algolia.vm';
import {SessionEvent} from '../../event-listeners/session/session.event';
import {ScrollEvent} from '../../event-listeners/scroll/scroll.event';
import {ResizeEvent} from '../../event-listeners/resize/resize.event';
import {PageEvent} from '../../event-listeners/event-page/event-page.event';
import { MobileConnectorService } from 'src/app/data/networking/services/shared/mobile-connector/mobile-connector.service';
import { GoogleTagService } from '../../../../data/networking/services/shared/google-tag/google-tag.service';

@Component({
  selector: 'app-algolia-search-box',
  templateUrl: './algolia-search-box.component.html',
  styleUrls: ['./algolia-search-box.component.scss'],
})
export class AlgoliaSearchBoxComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() idPrefix = '';
  @Input() colorNav;
  searchTextBox = '';
  searchTextBoxAux = '';
  arrayDeparments: any[] = [];
  filters = '';
  sendFilters = true;
  toggleListDeparments = false;
  optionDeparments = 'Categorías';
  initAlgolia = true;
  fixedBoxSearch = false;
  searchHomeR;
  screenSize = {desktop: true, mobile: false};
  firstView = true;
  input = {
    search: '',
  };
  hasVoiceSearch = false;
  searchVoiceInstance;
  @ViewChild('voiceSearch', {read: ViewContainerRef}) voiceSearch: ViewContainerRef;
  isBrowser;
  showRecommended = false;
  showAllComponents = false;

  public search: any;
  searchMarketplace = true;
  subscriptionList: Subscription[] = [];

  constructor(
    private algoliaSearchService: AlgoliaSearchService,
    private router: Router,
    private route: ActivatedRoute,
    private vmAlgolia: AlgoliaVm,
    private sessionEvent: SessionEvent,
    private scroll: ScrollEvent,
    private location: PlatformLocation,
    private cfr: ComponentFactoryResolver,
    private injector: Injector,
    private resizeEvent: ResizeEvent,
    private eventPage: PageEvent,
    private mcService: MobileConnectorService,
    private gtm: GoogleTagService,
    @Inject(PLATFORM_ID) platformId,
) {
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);

    this.searchHomeR = this.isBrowser && window.location.pathname === '/';

    this.eventPage.eventCallAllComponentsListener.subscribe((res: any) => {
      if (res.allComponents) {
        this.getAllServices();
      }
    });

    this.algoliaSearchService.searchNew = true;

    if(countryConfig.getService) {
      this.mcService.clearSearchBar.subscribe(()=> this.input.search = '');
    }
  }

  onTyping() {
    this.algoliaSearchService.searchNew = true;
    this.sendFilters = false;
    this.searchTextBox = this.searchTextBoxAux;
    this.searchTextBox = this.input.search;
    this.sendDataAlgolia();
  }

  selectDeparment(deparment) {
    if (this.optionDeparments !== deparment) {
      this.optionDeparments = deparment;
      this.sendFilters = false;
      this.sendDataAlgolia();
    }
  }

  sendDataAlgolia() {
    if (this.searchTextBox && this.searchTextBox !== '') {

      const urlParams = {
        product: this.searchTextBox,
        departamento: this.optionDeparments === 'Categorías' ? 'Todos' : this.optionDeparments,
        filtros: '',
      };

      if (this.sendFilters) {
        urlParams.filtros = this.filters;
      }

      this.router.navigate(['/buscar'], {queryParams: urlParams});
      const searchObj = {
        query: this.searchTextBox,
        filters: this.getFilters(),
      };

      if (this.sendFilters) {
        searchObj.filters += this.filters;
      }
      this.algoliaSearchService.changeSearch(searchObj);
    }
  }

  private getFilters() {
    const marketplaceFilter = this.searchMarketplace? '':' AND NOT product_type:"marketplace"';
    if (countryConfig.algoliaSearchComponent.getFIlterOption.department) {
      return (this.optionDeparments !== '' && this.optionDeparments !== 'Todos') ? ` AND departments: '${this.optionDeparments}'${marketplaceFilter}` : marketplaceFilter;
    }
    return (this.optionDeparments !== '' && this.optionDeparments !== 'Todos') ? ` AND categorie: '${this.optionDeparments}'${marketplaceFilter}` : marketplaceFilter;
  }

  async getVoiceSearch() {
    if (this.voiceSearch && countryConfig.isColombia) {
      this.voiceSearch.clear();
      const {VoiceSearchComponent} = await import('./voice-search/voice-search.component');
      const factory = this.cfr.resolveComponentFactory(VoiceSearchComponent);
      const {instance} = this.voiceSearch.createComponent(factory, null, this.injector);
      this.searchVoiceInstance = instance;
      instance.searchHomeR = this.searchHomeR;
      instance.fixedBoxSearch = this.fixedBoxSearch;
      instance.screenSize = this.screenSize;
      instance.voiceSearch.subscribe(search => {
        if (search) {
          this.onVoiceSearch(search);
        }
      });
    }
  }

  onVoiceSearch(search) {
    this.input = {search};
    this.onTyping();
  }

  ngOnInit() {
    this.resizeEvent.currentScreenSize
      .subscribe(size => {
        if (size) {
          this.screenSize = size;
        }
      });
    if(this.isBrowser){
      this.getRemoteConfig();
    }else{
      this.initSearch();
    }
    if (this.isBrowser && window.screen.width <= 786) {
      this.scroll.scrollWindow.subscribe((data: any) => {
        this.fixedBoxSearch = data >= 147;

        if (this.searchVoiceInstance) {
          this.searchVoiceInstance.ngOnChanges({
            fixedBoxSearch: new SimpleChange(null, this.fixedBoxSearch, false),
            screenSize: new SimpleChange(null, this.screenSize, false),
          });
        }
      });
      this.router.events.subscribe((events: any) => {
        if (events instanceof NavigationEnd) {
          this.searchHomeR = events.url === '/';

          if (this.searchVoiceInstance) {
            this.searchVoiceInstance.ngOnChanges({searchHomeR: new SimpleChange(null, this.searchHomeR, false)});
          }
        }
      });
    }

    this.location.onPopState(() => {
      this.route.queryParamMap.subscribe((data: any) => {
        this.searchTextBoxAux = data.params.product;
        this.input = {
          search: data.params.product,
        };
      });
    });

    const searchBox = document.getElementById('nav-bar-algolia-search-box');
    const keyup$ = fromEvent(searchBox, 'keyup');
  
      keyup$
      .pipe(
        map((i: any) => i.currentTarget.value),
       
        debounceTime(500)
      )
      .subscribe( (res) => {
        if ( res.length > 1 && res.trim() !== '') {
          this.onTyping();
        }
      });

    keyup$
      .pipe(
        map((i: any) => i.currentTarget.value),
        debounceTime(2000)
      )
      .subscribe();
  }
  hideforNative() { return this.mcService.isMobile;}

  ngAfterViewInit(): void {
    if( this.hideforNative() ) { return; }
    if (this.isBrowser && ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window)) {
      setTimeout(() => {
        this.hasVoiceSearch = true;
      });
    }
  }

  ngOnDestroy(): void {
    this.subscriptionList?.forEach(subscription => subscription?.unsubscribe());
  }

  getAllServices() {
    this.showAllComponents = true;
    this.sessionEvent.hasCustomer
    .subscribe(() => {
      const existsCustomer = this.vmAlgolia.getLocalCustomer();
      const existsDepartments = this.arrayDeparments?.length;
      if (existsCustomer && !existsDepartments) {
        this.getDepartments();
      }
    });
  }

  getDepartments() {
    this.vmAlgolia.getDepartments().subscribe((res: any) => {
      this.arrayDeparments = res.departmentList;
    });
  }

  searchRecommended(data) {
    this.input.search = data;
    this.onTyping();
    this.showRecommended = false;
  }

  getRemoteConfig() {

    const subscription = this.vmAlgolia.getRemoteConfig()
      .subscribe({
        next: config => {
          this.searchMarketplace = config?.searchMarketplace;
          this.initSearch();
        },
        error: (error) => {
          console.error('Failed to fetch remote config', error);
        },
      });

    this.subscriptionList.push(subscription);
  }
  initSearch(){
    if (this.initAlgolia) {
      this.route.queryParams.subscribe(params => {
        if (params.product && params.product !== '') {
          this.searchTextBox = params.product;
          if (this.firstView) {
            this.searchTextBoxAux = this.searchTextBox;
            this.input = {
              search: this.searchTextBox,
            };
            this.firstView = false;
          }
          if (params.departamento && params.product !== '') {
            this.optionDeparments = params.departamento;
          }
          if (params.filtros && params.filtros !== '') {
            this.filters = params.filtros;
            this.sendFilters = true;
          }
          this.initAlgolia = false;
          if (this.algoliaSearchService.searchNew) {
            this.sendDataAlgolia();
          }
        }
      });
    }
  }
}
